import React from "react";

function About() {
    return (
        <h3>About Page</h3>
    )
}

export default About;
